import { useEffect } from "react";
import { InfinitySpin } from "react-loader-spinner";

export default function GoogleRedirect () {
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");
        const error = urlParams.get("error");

        if (error) {
            localStorage.setItem("google_oauth_error", error);
            //   window.opener?.postMessage({ type: "oauth-error", error }, '*');
            window.close();
            return;
        }

        if (code) {
            localStorage.setItem("google_oauth_code", code);
            //   window.opener?.postMessage({ type: "oauth-code", code }, '*');
            window.close();
        }   
    }, []);

    return (
        <div className="googleLoader">
            <InfinitySpin height="80" width="200" radius="9" color="#D49D29" ariaLabel="loading" wrapperStyle wrapperClass />
            <p>Processing Google login</p>
        </div>
    );
};
